import React, { useLayoutEffect, useEffect, useMemo, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useTemplate, useUser } from 'components/hooks';
import { HeadlinePage, FormMonacoEditor } from 'components/common';
import { Input } from 'components/layout';
import { useTranslation } from 'react-i18next';
import { formatProjectItems, dataModelPolicies } from 'helpers';
import { useStyle } from './styles';
import { Paper, Button, Grid, CircularProgress, Backdrop, Typography } from '@mui/material';
import { ROUTES } from 'consts';


function createMapping(projects) {
  let result = {};
  projects.forEach((p, i) => {
    result[p.value] = p;
  });
  return result;
}

export default function DataModelFormDumb({ defaultValues, handleOnSubmit, isEdit }) {
  const { parameters } = useUser();
  const { getUserProject, isLoaded } = useTemplate();
  const [languageSelected, setLanguageSelected] = useState(defaultValues.language);
  const projects = formatProjectItems(parameters);
  const [t] = useTranslation();
  const classes = useStyle();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, watch, setValue, reset, control } = methods;
  const watchProject = watch('project');
  const projectsMap = createMapping(projects);

  const setDataQuery = () => {
    getUserProject({
      query: {
        projectId: projectsMap[watchProject].value,
        baseUrl: projectsMap[watchProject].base_url,
      },
    });
  };

  const changeLanguage = (language) => {
    setLanguageSelected(language);
    setValue('language', language);
  }

  const fields = [
    { policy: dataModelPolicies.name },
    { policy: {...dataModelPolicies.project, disabled: true}, options: projects },
  ];

  useEffect(() => {
    if (isEdit) {
      changeLanguage(defaultValues.language);
      reset(defaultValues)
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);

  useLayoutEffect(() => {
    setDataQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchProject]);


  return (
    <>
      <Backdrop
        sx={{ userSelect: 'none', pointerEvents: 'none' }}
        open={isLoaded.post || isLoaded.put}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage title={isEdit ? 'dataModelEdit.headline' : 'dataModelCreate.headline'} goBack={ROUTES.DATA_MODEL_LIST}/>

      <Paper className={classes.paperStyle}>
        <FormProvider { ...methods }>
          <form onSubmit={handleSubmit(handleOnSubmit)}>
            <Typography variant="h6" sx={{ padding: '8px 0px' }}>
              {t('dataModelList.form.title')}
            </Typography>

            <Grid container spacing={2}>
              { fields.map((field) => (
                <Grid key={field.policy.id} item xs={12} sm={12} md={6} lg={4}>
                  <Input
                    {...field.policy}
                    control={control}
                    options={field.options}
                    sx={{ width: '100%' }}
                  />
                </Grid>
              ))}

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <FormMonacoEditor
                  label={dataModelPolicies.additionalVariables.label}
                  name={dataModelPolicies.additionalVariables.name}
                  helperText={dataModelPolicies.additionalVariables.helperText}
                  methods={methods}
                  language={languageSelected}
                  handleSetLanguage={changeLanguage}
                  languageOptions={['json', 'yaml']}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} type='submit'>
                  {isEdit ? t('dataModelEdit.components.submit') : t('dataModelCreate.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
          </form>
        </FormProvider>
      </Paper>
    </>
  );
}
